export const Team = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.7922 16.0417H16.9556C17.9247 16.0417 18.7108 15.2074 18.4454 14.2754C17.8345 12.1308 16.3913 10.625 14.1672 10.625C13.7955 10.625 13.4456 10.6671 13.1178 10.7471M9.37548 5.83333C9.37548 7.3291 8.16292 8.54167 6.66715 8.54167C5.17138 8.54167 3.95882 7.3291 3.95882 5.83333C3.95882 4.33756 5.17138 3.125 6.66715 3.125C8.16292 3.125 9.37548 4.33756 9.37548 5.83333ZM16.4588 6.25C16.4588 7.51565 15.4328 8.54167 14.1671 8.54167C12.9015 8.54167 11.8755 7.51565 11.8755 6.25C11.8755 4.98435 12.9015 3.95833 14.1671 3.95833C15.4328 3.95833 16.4588 4.98435 16.4588 6.25ZM1.73487 15.105C2.38372 12.4889 4.04953 10.625 6.66715 10.625C9.28477 10.625 10.9506 12.4889 11.5994 15.105C11.8325 16.0449 11.0509 16.875 10.0825 16.875H3.2518C2.28345 16.875 1.50177 16.0449 1.73487 15.105Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Team
